import "core-js/modules/es6.array.filter";
import _has from "lodash/has";
import _uniqBy from "lodash/uniqBy";
import _each from "lodash/each";
import moment from 'moment';
import { getTransactions, getTransactionsMonthCashFlow, getCategoryWindowRollups } from "../actions/yodlee";
import { isRollupRequestInProgress, getTransactionData } from "../selectors/yodlee";
import { DATE_FORMAT } from "../constants";
/**
 * This middleware listens for events that change the number of transactions in
 * a transaction bucket (e.g. category bucket, merchant bucket):
 *
 * - getTransactions.SUCCESS_TYPE
 * - createMerchantCategoryRule.SUCCESS_TYPE
 * - recategorizeTransaction.SUCCESS_TYPE
 *
 * On such actions, we fetch new monthly cash flow rollups for EVERY month the
 * user has a transaction for.
 *
 * If the client is also running `transactionRollupsMiddleware`, then rollups
 * for the current and previous month will be fetched TWICE. Therefore, clients
 * should only include this middleware if their UI shows monthly rollups.
 */

export default (function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return function (action) {
      if (!process.browser) return next(action);
      var returnValue = next(action);

      var _getState = getState(),
          identity = _getState.identity;

      if (action.type === getTransactions.SUCCESS_TYPE) {
        var bucket = getTransactionData(identity, action.meta.filter);
        var haveMonthsMap = bucket.monthRollups; // Always include the current month even if there are no transactions
        // since $0 rollup vs undefined means the request has completed

        var needMonthsList = [moment().date(1).format(DATE_FORMAT.STANDARD)];

        _each(bucket.transactions, function (value) {
          needMonthsList.push(moment(value.date).date(1).format(DATE_FORMAT.STANDARD));
        });

        _each(_uniqBy(needMonthsList), function (month) {
          if (!haveMonthsMap[month] && !isRollupRequestInProgress(month, action.meta.filter)) {
            // when we have a category filter, we need to fetch category rollups
            // otherwise refetch spending vs earning rollups
            if (_has(action.meta.filter, 'category')) {
              dispatch(getCategoryWindowRollups({
                startDate: moment(month, DATE_FORMAT.STANDARD).startOf('month').format(DATE_FORMAT.STANDARD),
                endDate: moment(month, DATE_FORMAT.STANDARD).endOf('month').format(DATE_FORMAT.STANDARD)
              }));
            } else {
              dispatch(getTransactionsMonthCashFlow({
                dayInTargetMonth: moment(month, DATE_FORMAT.STANDARD).format(DATE_FORMAT.STANDARD),
                filter: action.meta.filter
              }));
            }
          }
        });
      }

      return returnValue;
    };
  };
});